import { SearchIcon, CloseIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Checkbox,
  CloseButton,
  Heading,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Text,
  VStack,
} from '@chakra-ui/react';
import {
  BlockMemberIcon,
  ChatMemberIcon,
  ExitGroup,
  MakeAdmin,
  MessageChatIcon,
  MyNetworkNewIcon,
  RemoveAdmin,
  RemoveMember,
  ReportIcon,
  TeamIcon,
  TeamNewIcon,
  ViewPofileIcon,
} from '@mybridge/icons';

import { Avatar } from '@mybridge/ui';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { MakeGroupAdmin, RemoveMemberApi } from 'v4/store/actions/global.data.actions';
import AddGroupAdminPopup from './add-group-admin-popup';
import { MyNetworkContext } from 'v4/components/network/context';
import { useRouter } from 'next/router';
import axios from 'axios';
import { blockRoomUser, blockUnblockRoomUser, removeRoomAdmin, unblockConnection } from 'v4/store/actions/connection.actions';
import { io } from 'socket.io-client';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { getRoomIdFromLS } from 'v4/utils/utils';

const MembersPopup = ({
  isMemberPopup,
  roomId,
  selectedMember,
  selectedMemberUserName,
  selectedMemberUserId,
  fetchRoomList,
  //   setIsMemberPopup,
  groupMemberDetail,
  isMembersPopupOpen,
  setIsMembersPopupOpen,
  onClose,
  getSelectedRoomMembersData
}) => {
  const router = useRouter();
  const { t } = useTranslator();
  const { blockUser, isFriend, setSelectedUser, reportUserDisc } = useContext(MyNetworkContext);
  const [addGroupAdminPopup, setAddGroupAdminPopup] = useState(false);
  const [isAdminPopup, setIsAdminPopup] = useState(false);
  const [isExitGroupPopup, setIsExitGroupPopup] = useState(false);
  const { userProfileInfo, userPresenceStatus } = useSelector(
    (state) => state.userProfile
  );
  const dispatch = useDispatch();
  const isAdmin = groupMemberDetail?.some(
    (member) =>
      member?.user_id === userProfileInfo?.id &&
      (member?.role === 'admin' || member?.role === 'owner')
  );
  const selectedUser = groupMemberDetail?.find((item) => item?.id !== userProfileInfo?.id);
  const isSeletedMemberAdmin = groupMemberDetail?.some(
    (member) =>
      member?.user_id === selectedMember?.user_id &&
      (member?.role === 'admin' || member?.role==='owner')
  );
  const isConnection = isFriend(selectedMember);
  const IsloggedInUser = userProfileInfo?.id === selectedMember?.id;
  const SOCKET_SERVER_URL = process.env.SOCKET_URL;

  // const socketRef = useRef(null);
  
  // useEffect(() => {
  //   socketRef.current = io(SOCKET_SERVER_URL);
  //   return () => socketRef.current?.disconnect();
  // }, []);
  
  const handleBlockUser = () => {
    dispatch(blockRoomUser({
      reason: "Blocked by admin",
      user_id: selectedMember?.id,
      action: "block",
      room_id: roomId
    }))
    .unwrap()
    .then(() => {
      // Emit socket events
      // socketRef?.current?.emit('chat_accepted', {
      //   room_id: roomId,
      //   user_id: userProfileInfo?.matrix_user_id,
      //   timestamp: Date.now()
      // });
      
      // socketRef?.current?.emit('chat_avatar_updated', {
      //   room_id: roomId,
      //   user_id: userProfileInfo?.matrix_user_id,
      //   timestamp: Date.now()
      // });
  
      // Refresh and close
      fetchRoomList();
      getSelectedRoomMembersData();
      onClose();
      setIsMembersPopupOpen(false);
    });
  };
  
  // Add socket listeners
  // useEffect(() => {
  //   const handleUpdate = () => {
  //     fetchRoomList();
  //   };
  
  //   if (socketRef?.current) {
  //     socketRef.current.on('chat_accepted', handleUpdate);
  //     socketRef.current.on('chat_avatar_updated', handleUpdate);
  //   }
  
  //   return () => {
  //     if (socketRef?.current) {
  //       socketRef.current.off('chat_accepted', handleUpdate);
  //       socketRef.current.off('chat_avatar_updated', handleUpdate);
  //     }
  //   };
  // }, [socketRef?.current]);
  

 const removeMemberFunction=()=>{
  dispatch(RemoveMemberApi({ room_id: roomId, user_id: selectedMemberUserId }))
  .then((res) => {
    if (res.error) {
      console.error("Remove memeber failed:", res?.error?.message);
      return;
    }

    // onClose() //closes the all members popup
    getSelectedRoomMembersData();
    setAddGroupAdminPopup(false);
    setIsMembersPopupOpen(false);
    setIsExitGroupPopup(false);
  });
 }


 const adminCount = groupMemberDetail?.filter(member => member?.role === 'admin')?.length;
 const isSingleAdmin = adminCount === 1 && isSeletedMemberAdmin;
 
 const handleRemoveMember = () => {
  const adminCount = groupMemberDetail?.filter(member => member?.role === 'admin')?.length;
  
  if (isSeletedMemberAdmin && adminCount === 1) {
    // Show modal/popup for single admin case
    setIsAdminPopup(true);
  } else {
    // removeMemberFunction();
  }
};

const MakeGroupAdmins = () => {
  dispatch(MakeGroupAdmin({ room_id: roomId, user_id: selectedMemberUserId }))
    .then((res) => {
      if (res.error) {
        console.error("MakeGroupAdmin failed:", res?.error?.message);
        // Handle error (e.g., show a notification)
        return;
      }

      // Refresh the admin list
      getSelectedRoomMembersData();

      // Close popups if API call succeeds
      setAddGroupAdminPopup(false);
      setIsMembersPopupOpen(false);
    });
};

const accessToken = 
    typeof window !== 'undefined' ? localStorage.getItem('access') : null;



// const handleRemoveAdmin = async () => {
//   if (!accessToken) {
//     console.error("No access token found, user is not authenticated.");
//     return;
//   }

//   try {
//     const response = await axios.delete('https://api.bybk.org/api/v1/matrix/room/admin', {
//       headers: {
//         'Content-Type': 'application/json',
//         Authorization: `Bearer ${accessToken}`,
//       },
//       data: {
//         room_id: roomId,
//         user_id: selectedMemberUserId

//       }
//     });

//     if (response.status >= 200 && response.status < 300) {
//       console.log("Remove Admin Success:", response.data);
//       getSelectedRoomMembersData();
//       setAddGroupAdminPopup(false);
//       setIsMembersPopupOpen(false);
//     } else {
//       console.error("Failed to remove admin:", response.data);
//     }
//   } catch (error) {
//     console.error("Error removing admin:", error.response?.data || error.message);
//   }
// };

const handleRemoveAdmin = () => {
  dispatch(removeRoomAdmin({
    room_id: roomId,
    user_id: selectedMemberUserId
  }))
  .unwrap()
  .then(() => {

    getSelectedRoomMembersData();
    setAddGroupAdminPopup(false);
    setIsMembersPopupOpen(false);
  })
  .catch((error) => {
    console.error("Error removing admin:", error);
  });
};



  return (
    <>
      <Modal
        isOpen={isMembersPopupOpen}
        onClose={() => {
          //   setIsGroupModalOpen(false);
          setIsMembersPopupOpen(false);
        }}
      >
        {/* <ModalOverlay /> */}
        <ModalContent marginTop="150px">
          {/* <ModalCloseButton /> */}
          <ModalHeader></ModalHeader>
          <ModalBody>
            {isAdmin ? (
              <VStack alignItems="start" gap={'16px'}>
                {(isConnection && !IsloggedInUser) && <HStack alignItems="center" cursor="pointer" gap="10px" 
                onClick={() => {
                  const roomId = selectedMember?.direct_room_id || getRoomIdFromLS(selectedMember?.user_id);
                  router.push(`/profile/message?user=${roomId}`)
                }}>
                  <Box
                    width="30px"
                    height="30px"
                    backgroundColor="#D9D9D9"
                    borderRadius="50%"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <MessageChatIcon width="16" height="16" />
                  </Box>
                  <Text
                    fontSize="15px"
                    fontWeight={400}
                    lineHeight="30px"
                    fontFamily="Inter"
                    color="#747474"
                  >
                    {t('profileNetwork.message') || "Message"}
                  </Text>
                </HStack>}
                <HStack cursor="pointer"   
                onClick={() =>
                    router.push(`/p/${selectedMember?.slug}`)
                  }>
                  <Box
                    width="30px"
                    height="30px"
                    backgroundColor="#D9D9D9"
                    borderRadius="50%"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <ViewPofileIcon color="#5B5B5B" width="18" height="18" />
                  </Box>
                  <Text
                    fontSize="15px"
                    fontWeight={400}
                    lineHeight="30px"
                    fontFamily="Inter"
                    color="#747474"
                  >
                    {t('myMessages.viewProfile') || "View profile"}
                  </Text>
                </HStack>

                {!IsloggedInUser && <HStack cursor="pointer" onClick={()=> handleBlockUser()}>
                  <Box
                    width="30px"
                    height="30px"
                    backgroundColor="#D9D9D9"
                    borderRadius="50%"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <BlockMemberIcon width="18" height="18" />
                  </Box>
                  <Text
                    fontSize="15px"
                    fontWeight={400}
                    lineHeight="30px"
                    fontFamily="Inter"
                    color="#747474"
                  >
                    {t('profileNetwork.block') || "Block"}
                  </Text>
                </HStack>}
            { !isSeletedMemberAdmin &&   <HStack
                  cursor="pointer"
                  onClick={() => {
                    setAddGroupAdminPopup(true);
                  }}
                >
                  <Box
                    width="30px"
                    height="30px"
                    backgroundColor="#D9D9D9"
                    borderRadius="50%"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <MakeAdmin width="16.01" height="16" />
                  </Box>
                  <Text
                    fontSize="15px"
                    fontWeight={400}
                    lineHeight="30px"
                    fontFamily="Inter"
                    color="#747474"
                  >
                    {t('myMessages.makeAdmin') || "Make Admin"}
                  </Text>
                </HStack>}
                {(isSeletedMemberAdmin && !isSingleAdmin) && <HStack
                  cursor="pointer"
                  onClick={handleRemoveAdmin}
                >
                  <Box
                    width="30px"
                    height="30px"
                    backgroundColor="#D9D9D9"
                    borderRadius="50%"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <RemoveAdmin width="16.01" height="16" />
                  </Box>
                  <Text
                    fontSize="15px"
                    fontWeight={400}
                    lineHeight="30px"
                    fontFamily="Inter"
                    color="#747474"
                  >
                    {t('myMessages.removeAdmin') || "Remove Admin"}
                  </Text>
                </HStack>}
                <HStack
                  cursor="pointer"
                  onClick={() => {
                    // removeMemberFunction();
                    // handleRemoveMember();
                    setIsExitGroupPopup(true);
                  }}
                >
                  <Box
                    width="30px"
                    height="30px"
                    backgroundColor="#D9D9D9"
                    borderRadius="50%"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <RemoveMember width="18" height="18" />
                  </Box>
                  <Text
                    fontSize="15px"
                    fontWeight={400}
                    lineHeight="30px"
                    fontFamily="Inter"
                    color="#747474"
                  >
                    {t('profile.remove') || "Remove"}
                  </Text>
                </HStack>
                {!IsloggedInUser && <HStack
                  cursor="pointer"
                  onClick={() => {
                    setSelectedUser(selectedUser)
                    reportUserDisc?.onOpen?.();
                  }}
                >
                  <Box
                    width="30px"
                    height="30px"
                    backgroundColor="#D9D9D9"
                    borderRadius="50%"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <ReportIcon width="18" height="15" />
                  </Box>
                  <Text
                    fontSize="15px"
                    fontWeight={400}
                    lineHeight="30px"
                    fontFamily="Inter"
                    color="#747474"
                  >
                    {t('profilePhotosVideos.report') || "Report"}
                  </Text>
                </HStack>}
              </VStack>
            ) : (
              <VStack alignItems="start" gap={'16px'}>
                <HStack cursor="pointer" 
                  onClick={() =>
                    router.push(`/p/${selectedMember?.slug}`)
                  }
                >
                  <Box
                    width="30px"
                    height="30px"
                    backgroundColor="#D9D9D9"
                    borderRadius="50%"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <ViewPofileIcon color="#5B5B5B" width="18" height="18" />
                  </Box>
                  <Text
                    fontSize="15px"
                    fontWeight={400}
                    lineHeight="30px"
                    fontFamily="Inter"
                    color="#747474"
                  >
                    {t('myMessages.viewProfile') || "View profile"}
                  </Text>
                </HStack>
                {(userProfileInfo?.id===selectedMember?.id) && <HStack alignItems="center" cursor="pointer" gap="10px"
                 onClick={() => {
                  removeMemberFunction();
                }}
                >
                  <Box
                    width="30px"
                    height="30px"
                    backgroundColor="#D9D9D9"
                    borderRadius="50%"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <ExitGroup width="17.92" height="16" />
                  </Box>
                  <Text
                    fontSize="15px"
                    fontWeight={400}
                    lineHeight="30px"
                    fontFamily="Inter"
                    color="#747474"
                  >
                    {t('myMessages.exitGroup') || "Exit Group"}
                  </Text>
                </HStack>}
              </VStack>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>

      {addGroupAdminPopup && (
        <AddGroupAdminPopup
        isModal={addGroupAdminPopup}
          MakeGroupAdmins={() => MakeGroupAdmins()}
          onClose={() => setAddGroupAdminPopup(false)}
          selectedMemberUserName={selectedMemberUserName}
        />
      )}
      {isExitGroupPopup && 
      // <Modal isOpen={isAdminPopup} onClose={() => setIsAdminPopup(false)}>
      //   <ModalContent>
      //     <ModalHeader>Assign a new admin</ModalHeader>
      //     <ModalBody>
      //       <Text>You are the only admin of this group. To ensure continued management, please assign a new admin before leaving.</Text>
      //       <Button mt={4} onClick={() => setIsAdminPopup(false)}>
      //         Close
      //       </Button>
      //     </ModalBody>
      //   </ModalContent>
      // </Modal>
      <Modal isOpen={isExitGroupPopup} onClose={() => setIsExitGroupPopup(false)} isCentered>
        <ModalOverlay />
        <ModalContent 
        backgroundColor="#FFFFFF"
        padding="5px 5px 0px 5px"
        maxWidth="436px"
        borderRadius="16px"
        >
          <ModalHeader>
            <HStack alignItems='center' justifyContent='space-between'>
                <Heading fontSize="15px" fontFamily="Inter" lineHeight="18px" fontWeight={600} color="#5B5B5B">
                {isSingleAdmin ? t('myMessages.assignNewAdmin') || "Assign a new admin" : (t('profile.remove') || "Remove")}
                </Heading>
                <CloseIcon cursor="pointer" width="15px" height="15px" color="#5B5B5B" fontWeight={600}  onClick={() => setIsExitGroupPopup(false)}/>
            </HStack>
          </ModalHeader>
          <ModalBody>
            <Text maxWidth="388px" w="100%">
            {isSingleAdmin ? t('myMessages.onlyAdminWarning') || "You are the only admin of this group. To ensure continued management, please assign a new admin before leaving." : `${t('otherModules.confirmRemove') || "Are you sure you want to remove"} ${selectedMember?.display_name}?`}
              <Text display="inline" fontWeight="bold">
                {/* "{getFullFileName(selectedFile)}" */}
              </Text>
            </Text>
          </ModalBody>
          <ModalFooter>
            <HStack>
              <Button 
              backgroundColor="transparent"
              border= "1px solid #D9D9D9"
              borderRadius="76px"
              p="9px 18px"
              fontSize="12px"
              fontWeight={500}
              lineHeight="14.4px"
              color="#3D5A80"
              _hover={{
                backgroundColor:"transparent"
              }}
              onClick={()=>{
                setIsExitGroupPopup(false)
              }}
              >
                {t('buttons.cancel') || "Cancel"}
              </Button>
              {!isSingleAdmin && <Button
                backgroundColor="#ff5435ff"
                border= "1px solid #D9D9D9"
                borderRadius="76px"
                p="9px 18px"
                fontSize="12px"
                fontWeight={500}
                lineHeight="14.4px"
                color="#FFFFFF"
                _hover={{
                backgroundColor:"#ff3300ff"
              }}
              onClick={()=>removeMemberFunction()}
              >
                {t('profile.remove') || "Remove"}
              </Button>}
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
      }
    </>
  );
};

export default MembersPopup;
